var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Lista fatture elettroniche per cassa")])
}
var staticRenderFns = []

export { render, staticRenderFns }